import React from 'react'

export const NumberInput = ({config, currentValue, onChange}) => {
  const min = config?.min
  const max = config?.max

  // Validation logic
  const numericValue = currentValue === '' ? null : Number(currentValue)
  const isValidNumber = currentValue === '' || !isNaN(numericValue)
  const isBelowMin =
    min !== undefined && numericValue !== null && numericValue < min
  const isAboveMax =
    max !== undefined && numericValue !== null && numericValue > max
  const isInvalid = !isValidNumber || isBelowMin || isAboveMax

  const getValidationMessage = () => {
    if (!isValidNumber) return 'Please enter a valid number'
    if (isBelowMin) return `Value must be at least ${min}`
    if (isAboveMax) return `Value must be no more than ${max}`
    return null
  }

  const getRangeHint = () => {
    if (min !== undefined && max !== undefined) {
      return `Range: ${min} - ${max}`
    }
    if (min !== undefined) return `Minimum: ${min}`
    if (max !== undefined) return `Maximum: ${max}`
    return null
  }

  const handleChange = e => {
    const value = e.target.value
    // Allow empty value or valid number input
    if (value === '' || !isNaN(Number(value))) {
      onChange(value)
    }
  }

  const handleBlur = () => {
    // Clamp value to min/max on blur if out of range
    if (currentValue !== '' && !isNaN(numericValue)) {
      let clampedValue = numericValue
      if (min !== undefined && numericValue < min) {
        clampedValue = min
      } else if (max !== undefined && numericValue > max) {
        clampedValue = max
      }

      if (clampedValue !== numericValue) {
        onChange(String(clampedValue))
      }
    }
  }

  const placeholder = `Enter value${min !== undefined ? ` (min: ${min})` : ''}${
    max !== undefined ? ` (max: ${max})` : ''
  }`

  return (
    <div className="custom-field-wrapper">
      <label className="custom-field-label">
        <span className="custom-field-label-text">{config?.label}</span>
        <input
          type="number"
          className={`custom-field-input ${
            isInvalid && currentValue !== '' ? 'error' : ''
          }`}
          min={min}
          max={max}
          value={currentValue}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder={placeholder}
        />
        {isInvalid && currentValue !== '' && (
          <span className="custom-field-error">{getValidationMessage()}</span>
        )}
        {(min !== undefined || max !== undefined) && !isInvalid && (
          <span className="custom-field-hint">{getRangeHint()}</span>
        )}
      </label>
    </div>
  )
}
